import { TrashAlt } from '@assets/svgs';
import { TextField } from '@components/textField';
import { Tooltip } from '@components/tooltip';
import { Avatar, Typography, Link as MuiLink, Box } from '@mui/material';
import { Button } from '@components/button';
import { IconButton } from '@components/iconButton';
import { getIconForMimeType } from '@utils/fileUtils';

export const FileListItem = ({
  isCollapsed,
  fileName,
  fileSize,
  fileType,
  description,
  downloadUrl,
  onChangeDescription,
  onBlurDescription,
  onDelete,
  isLoading,
}: {
  isCollapsed: boolean;
  fileName: string;
  fileSize?: number;
  fileType?: string;
  description?: string;
  downloadUrl?: string;
  onChangeDescription: (value: string) => void;
  onBlurDescription: () => void;
  onDelete: () => void;
  isLoading: boolean;
}) => {
  // TODO colors should be in theme
  const Icon = getIconForMimeType(fileType);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: '8px 0',
        gap: '16px',
      }}
    >
      <Box sx={{ display: 'flex', flexDirection: 'row', minWidth: 0 }}>
        <Avatar
          sx={{
            backgroundColor: '#F40F02', // THEME-TODO investigation
            marginRight: '16px',
            width: 36,
            height: 36,
          }}
          variant='rounded'
        >
          <Icon />
        </Avatar>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-start',
            minWidth: 0,
            overflow: 'hidden',
          }}
        >
          <MuiLink href={downloadUrl} sx={{ textDecoration: 'none', minWidth: 0 }}>
            <Tooltip title={fileName} placement='top-start'>
              <Button
                variant='text'
                sx={{
                  marginTop: '-6px',
                  maxWidth: '100%',
                  whiteSpace: 'nowrap',
                }}
                disabled={!downloadUrl}
              >
                {fileName}
              </Button>
            </Tooltip>
          </MuiLink>
        </Box>
        {isCollapsed ? (
          <Box sx={{ display: 'flex', marginLeft: '20px' }}>
            <Typography
              sx={{
                alignSelf: 'center',
              }}
              variant='bodySmall'
            >
              {description}
            </Typography>
          </Box>
        ) : null}
      </Box>
      {isCollapsed ? null : (
        <Box sx={{ display: 'flex', flexDirection: 'row', flexShrink: 0 }}>
          {fileSize ? <Typography variant='bodySmall'>60kb</Typography> : null}
          <TextField
            placeholder='Description'
            value={description}
            onChange={(e) => onChangeDescription(e.target.value)}
            onBlur={onBlurDescription}
            sx={{ width: '350px' }}
          />
          <IconButton
            disabled={isLoading}
            onClick={onDelete}
            sx={{
              marginLeft: '8px',
              svg: {
                color: 'icon.dark',
              },
            }}
          >
            <TrashAlt />
          </IconButton>
        </Box>
      )}
    </Box>
  );
};
